import PLACEHOLDER from '../../../../assets/images/scales/placeholder.png';

/**
 * Imagens das opções das escalas. A opção declara só o nome do arquivo final
 * (`image: 'glogau-1.png'`, ou `{ female, male }` quando muda com o sexo);
 * o arquivo é procurado em src/assets/images/scales/ e, enquanto não existir,
 * vale o placeholder neutro. Basta salvar a imagem com o nome declarado.
 */
// Chamada direta: o webpack só reconhece require.context nessa forma (um
// `typeof require.context` vira outro módulo e sempre dá falso).
const context = require.context('../../../../assets/images/scales', false, /\.(png|jpe?g|webp|svg)$/);

const AVAILABLE = new Set(context.keys());

function fileSrc(file) {
  const key = `./${file}`;
  return AVAILABLE.has(key) ? context(key) : PLACEHOLDER;
}

/** Sem sexo informado, vale a figura feminina. '0' = masculino no cadastro. */
function isMale(gender) {
  return String(gender) === '0';
}

export function hasOptionImage(option) {
  return Boolean(option && option.image);
}

export function resolveOptionImage(option, gender) {
  if (!hasOptionImage(option)) return null;
  const file = typeof option.image === 'string'
    ? option.image
    : (isMale(gender) && option.image.male) || option.image.female || option.image.male;
  return file ? fileSrc(file) : PLACEHOLDER;
}

export { PLACEHOLDER as SCALE_IMAGE_PLACEHOLDER };
